import React, {useEffect, useState} from "react";
import {useProductListContext} from "../productListProvider/ProductListProvider";
import {ProductListOrder, ProductListOrderBy} from "../../../typescript-library";
import {useTranslation} from "react-i18next";
import Select, {SelectOptionType} from "../../molecules/Select";
import {useMediaQuery} from "react-responsive";
import RadioButton from "../../lib/form/RadioButton/RadioButton";

export type SortOption = SelectOptionType & {
  orderBy: ProductListOrderBy;
  order: ProductListOrder;
};

const ProductSortInput: React.FC = () => {
  const {state, dispatch} = useProductListContext();
  const {t} = useTranslation();
  const isMobile = useMediaQuery({query: "(max-width: 940px)"});

  const sortOptions: SortOption[] = [
    {
      value: 1,
      text: t("product.mostPopular"),
      orderBy: "rank",
      order: "asc",
    },
    {
      value: 2,
      text: t("product.highestRebate"),
      orderBy: "percentageDiscount",
      order: "desc",
    },
    {
      value: 3,
      text: t("product.highestPrice"),
      orderBy: "price",
      order: "desc",
    },
    {
      value: 4,
      text: t("product.lowestPrice"),
      orderBy: "price",
      order: "asc",
    },
    {
      value: 5,
      text: t("product.latest"),
      orderBy: "newest",
      order: "desc",
    },
  ];

  const [selectedOptionValueNumber, setSelectedOptionValueNumber] = useState<number>(
    Number(sortOptions.find((so) => so.orderBy === state.orderBy && so.order === state.order)?.value) ?? 1,
  );

  useEffect(() => {
    const item = sortOptions.find((option) => {
      return option.orderBy === state.orderBy && option.order === state.order;
    });
    setSelectedOptionValueNumber(item ? (item.value as number) : 1);
  }, [state.order, state.orderBy]);

  const onChange = (value: string | number) => {
    const item = sortOptions.find((option) => option.value === Number(value));
    setSelectedOptionValueNumber(item ? (item.value as number) : 1);
    dispatch({
      type: "SET_SORT",
      payload: {orderBy: item?.orderBy ?? undefined, order: item?.order ?? undefined, doUrlParamUpdate: true},
    });
  };

  return (
    <>
      {!isMobile && (
        <>
          <Select
            value={selectedOptionValueNumber}
            styles={{
              wrapper: "filter-sort__dd",
              option: "dd__option--highlighted",
            }}
            label={t("product.sortSelectLabel")}
            showLabel={false}
            onChange={onChange}
            options={sortOptions}
          />
        </>
      )}
      {isMobile && (
        <div className="filter-sort__list mb-8">
          {sortOptions.map((option) => {
            return (
              <div key={option.value} className="py-3">
                <RadioButton
                  value={option.value}
                  checked={selectedOptionValueNumber === option.value}
                  name={"sort"}
                  onChange={(evt) => {
                    onChange(evt.target.value);
                  }}
                >
                  {option.text}
                </RadioButton>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default ProductSortInput;
